import { render, staticRenderFns } from "./modifyEmail.vue?vue&type=template&id=74bb570b&scoped=true"
import script from "./modifyEmail.vue?vue&type=script&lang=js"
export * from "./modifyEmail.vue?vue&type=script&lang=js"
import style0 from "./modifyEmail.vue?vue&type=style&index=0&id=74bb570b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb570b",
  null
  
)

export default component.exports